var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPresentationPlanning01 = function SvgPresentationPlanning01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.694 18.452 2.5 15.258l1.044-1.045 2.125 2.125 4.25-4.25 1.044 1.07zm0-7.616L2.5 7.642l1.044-1.044L5.67 8.723l4.25-4.25 1.044 1.07zm7.315 5.722v-1.5h8.5v1.5zm0-7.616v-1.5h8.5v1.5z"
  })));
};
export default SvgPresentationPlanning01;